import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "content-based-process-automation"
    }}>{`Content Based Process Automation`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Analysis of the content contained in PDF documents is often required to enable business-critical work processes and decision-making. However, manual analysis of documents is expensive, time consuming, and error prone. Accurate extraction of content and context from PDF documents so it can be analyzed by intelligent bots or Robotic Process Automation technology allows processes to be automated, creating new efficiencies, enabling deeper insights, and empowering better decision-making. For example, analysis of long form documents such as sales contracts can be automated to identify which contain non-standard clauses or to ensure the contracts are adhering to certain regulatory or compliance standards.`}</p>
    <h3 {...{
      "id": "apis-used"
    }}>{`APIs Used`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-extract.md"
        }}>{`Adobe PDF Extract API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A large software company wants to extract content from its marketing literature to enable an automated chat bot on its web site to help prospective customers learn about its offerings. In this scenario, it’s important to capture the richness of the marketing material so the chatbot experience can deliver maximum impact.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this solution`}</h3>
    <ol>
      <li parentName="ol">{`Pass a PDF to Adobe PDF Extract API to retrieve text content`}</li>
      <li parentName="ol">{`Extract headings and paragraph text from the JSON parsed content`}</li>
      <li parentName="ol">{`Take user input as a search to return response candidates`}</li>
      <li parentName="ol">{`Rank results to select top response(s)`}</li>
      <li parentName="ol">{`Display PDF using PDF Embed API with integrated chatbot using callback functions`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      